import React, { useState, useCallback, Component } from 'react';
import { useGmailStatus } from '../../../hooks/useGmailStatus';
import { useEmailInbox } from '../../../hooks/useEmailInbox';
import GmailAuthPrompt from './GmailAuthPrompt';
import EmailInboxList from './EmailInboxList';
import EmailThreadView from './EmailThreadView';

class EmailInboxErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex-1 flex items-center justify-center">
          <span className="loading loading-spinner loading-md" />
        </div>
      );
    }
    return this.props.children;
  }
}

function EmailInboxContent() {
  const { emails, isLoading, error } = useEmailInbox();
  const [selectedThread, setSelectedThread] = useState(null);

  const handleSelectThread = useCallback((threadId, studentId) => {
    setSelectedThread({ threadId, studentId });
  }, []);

  if (selectedThread) {
    return (
      <EmailThreadView
        threadId={selectedThread.threadId}
        studentId={selectedThread.studentId}
        onBack={() => setSelectedThread(null)}
      />
    );
  }

  if (error) {
    return (
      <div className="p-4">
        <div className="alert alert-error text-sm">{error}</div>
      </div>
    );
  }

  return (
    <EmailInboxList
      emails={emails}
      isLoading={isLoading}
      onSelectThread={handleSelectThread}
    />
  );
}

export default function EmailPanel() {
  const { connected, loading } = useGmailStatus();

  if (loading) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <span className="loading loading-spinner loading-md" />
      </div>
    );
  }

  if (!connected) {
    return <GmailAuthPrompt />;
  }

  return (
    <EmailInboxErrorBoundary>
      <EmailInboxContent />
    </EmailInboxErrorBoundary>
  );
}
